import { Dispatch, SetStateAction } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IntegranteDisponible, resetEquipoCustom } from '../../../../store/equiposVentaSlice';
import { EquipoVentas } from '../../../../types/vendedor';
import { ErrorMessage } from '../../../../components/errors/ErrorMessage';
import { EquiposDisponibles } from './EquiposDisponibles';
import { IntegrantesNuevoEquipo } from './IntegrantesNuevoEquipo';
import { selectCurrentUserRole } from '../../../../api/auth/authSlice';
import { ActionButtons } from 'src/components/ui/ActionButtons';

interface Props {
    handleCreateCustomTeam: () => Promise<void>;
    equiposDisponibles?: EquipoVentas[];
    isLoading: boolean;
    errorMessage: string | null;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
    enableSaveButton: boolean;
    primerIntegrante?: IntegranteDisponible;
    segundoIntegrante?: IntegranteDisponible;
    textoNuevoEquipo: string;
}

export function FormularioCreacionEquipos({ 
    enableSaveButton,
    errorMessage,
    setErrorMessage,
    equiposDisponibles,
    handleCreateCustomTeam,
    isLoading ,
    primerIntegrante,
    segundoIntegrante,
    textoNuevoEquipo,
}: Props) {
    const dispatch = useDispatch();
    const userRole = useSelector(selectCurrentUserRole);

    if (userRole !== "Administrador")
        return (<div></div>);

    return (
        <div className="h-full flex-1 min-h-0 flex flex-col gap-y-2">

            <IntegrantesNuevoEquipo 
                titulo={textoNuevoEquipo}
                primerIntegrante={primerIntegrante}
                segundoIntegrante={segundoIntegrante}/>

            <ActionButtons 
                isLoading={isLoading}
                disabledSaveButton={!enableSaveButton}
                saveButtonType="button"
                saveButtonText="Guardar"
                onSave={handleCreateCustomTeam}
                onCancel={() => {
                    dispatch(resetEquipoCustom());
                    setErrorMessage(null);
                }}
                />

            {errorMessage && (
                <div className="my-2">
                    <ErrorMessage
                        customMessage>
                        <p className="text-sm">{errorMessage}</p>
                    </ErrorMessage>
                </div>
            )}

            <EquiposDisponibles
                equiposDisponibles={equiposDisponibles}/>

        </div>
    );
}
